export default __webpack_public_path__ + "static/media/22-3936753.59b8702d.png";